import React, { useState, useContext } from "react";
import { navigate } from "gatsby";
import { Button, TextField, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { SiteContext } from "gatsby-frontend/src/Site";

function Search({
	onSubmit,
	placeholder = "Search this website...",
	variant = "outlined",
	autoFocus = false,
}) {
	const { isPrivate, privateRoute } = useContext(SiteContext);
	const [searchQuery, setSearchQuery] = useState(null);
	const searchPath = isPrivate ? `${privateRoute}/search` : "/search";

	function handleSubmit(e) {
		e.preventDefault();
		if (onSubmit) {
			onSubmit(e);
		}
		if (searchQuery) {
			navigate(`${searchPath}?query=${searchQuery}`);
		}
	}
	return (
		<Box
			sx={{ display: "flex" }}
			component="form"
			onSubmit={handleSubmit}
			className="search-form"
		>
			<TextField
				autoFocus={autoFocus}
				label={placeholder}
				fullWidth
				variant={variant}
				sx={(theme) => ({
					marginRight: theme.spacing(2),
					backgroundColor: variant === "filled" ? theme.palette.body.light : "",
				})}
				onChange={(e) => {
					let val =
						e.target.value && e.target.value.length > 0 ? e.target.value : null;
					setSearchQuery(val);
				}}
			/>
			<Button variant="contained" type="submit">
				<SearchIcon />
			</Button>
		</Box>
	);
}

export default Search;
